import React from 'react';
import { motion } from 'framer-motion';
type FadeUpProps = {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  as?: 'div' | 'section' | 'span' | 'li';
};

/**
 * Subtle, restrained fade-up on scroll into view. Single motion primitive used site-wide.
 */
export function FadeUp({
  children,
  delay = 0,
  className = '',
  as = 'div'
}: FadeUpProps) {
  const MotionTag = motion[as];
  return <MotionTag className={className} initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.7,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-48" data-mp="2rxe6u8wzujm">
      {children}
    </MotionTag>;
}